import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { Pressable, View } from 'react-native';
import { CREATE_SALESPERSON, SELECT_OPTIONS } from './queries';
import { ButtonContainer } from './elements';
import Autocomplete from '../Autocomplete';
import { salespersonRadioButtons } from 'app/src/elements/inputs';

const NewSalesPerson = ({setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();
  const [vendorOrUser, setVendorOrUser] = useState('Vendor');
  const [selectOptions, setSelectOptions] = useState([]);
  const [createSalesPerson] = useMutation(CREATE_SALESPERSON, {
    onCompleted: () => {
      if(refetch) {
        refetch();
      }
      setShowModal(false);
    }
  });

  const { loading: loading, error: error, data: data } = useQuery(SELECT_OPTIONS);

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createSalesPerson({ variables: input });
  });

  const { control, handleSubmit, watch, register, setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      vendorId: '',
      userId: '',
      commissionId: '',
      sellerId: ''
    }
  });

  useEffect(() => {
    if(data) {
      setSelectOptions(data);
    }
  }, [data]);

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        <DataState.Loading /> :
        <View>
          {salespersonRadioButtons(vendorOrUser, setVendorOrUser, setValue)}
          {vendorOrUser === 'Vendor' ?
            <Input.Picker
              label='Vendor:'
              name='vendorId'
              control={control}
              errors={errors}
              options={selectOptions?.vendors?.map(vendor => {
                return { value: vendor.id, label: vendor.name }
              })}
              {...register("vendorId", {
                required: vendorOrUser === 'Vendor',
                validate: (val) => {
                  if (watch('vendorId') === 'Select') {
                    return "Required";
                  }
                },
              })}
            /> :
            <Input.Picker
              label='User:'
              name='userId'
              control={control}
              errors={errors}
              options={selectOptions?.users?.map(user => {
                return { value: user.id, label: `${user.firstName} ${user.lastName}` }
              })}
              {...register("userId", {
                required: vendorOrUser === 'User',
                validate: (val) => {
                  if (watch('userId') === 'Select') {
                    return "Required";
                  }
                },
              })}
            />
          }
          <Input.Picker
            label='Commission:'
            name='commissionId'
            control={control}
            errors={errors}
            options={selectOptions?.commissions?.map(commission => {
              return { value: commission.id, label: commission.name }
            })}
            {...register("commissionId", {
              required: "Required",
              validate: (val) => {
                if (watch('commissionId') === 'Select') {
                  return "Required";
                }
              },
            })}
          />
          <Input.Picker
            label='Seller:'
            name='sellerId'
            control={control}
            errors={errors}
            options={selectOptions?.sellers?.map(seller => {
              return { value: seller.id, label: seller.name }
            })}
            {...register("sellerId", {
              required: "Required",
              validate: (val) => {
                if (watch('sellerId') === 'Select') {
                  return "Required";
                }
              },
            })}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create SalesPerson" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewSalesPerson;
